<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">{{routeName}}</div>
        </div>
        <!-- div class="col-md-2 offset-md-2 text-right center">
          <button type="submit" class="btn btn-primary btn-fill" @click="changeListOrder">Change List Order</button>
        </div -->
        <div class="col-md-4 text-right center">
          <button type="submit" class="btn btn-primary btn-fill" @click="createTeaserLine">Add Teaser Line</button>
        </div>
      </div>
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <!-- div class="h2">{{routeName}}ABC</div -->
          <div class="col-md-8 left">
            <div class="col-8" v-if="status.length">
              <fg-select
                label="Resource Type"
                v-model="filter"
                :list="status"
                selectedKey="id"
              >
              </fg-select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive text-center">
        <l-table class="table table-light table-bordered table-hover"
                 :columns="teasers.columns" :data="teasers.data">
          <template slot="table-row" v-if="teasers.data.length">
            <tr v-for="(item, index) in teasers.data" :key="index">
              <!--td><img :src="item.smallImage" alt="corporation-image" class="table-thumbnail"></td-->
              <td>{{item.eid}}</td>
              <td>{{item.messageText}}</td>
              <td>
              <div class="btn-group" role="group">
              <button class="btn btn-info btn-sm" @click="editTemplate(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
              </div>
              </td>
            </tr>
          </template>
        </l-table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  const columns = ['Id', 'Content', 'Actions'];
  export default {
    name: 'Teasers',
    components: {
      LTable,
    },
    data() {
      return {
        downloadUrl: '',
        tooltips: {
          view: 'View',
          edit: 'Edit',
          delete: 'Inactivate',
          activate:'Activate',
        },
        filter: 1,
        dateRef: 'Date Created',
        status: [{id:"1", name:'Email Subject'}, {id:"2", name:'Email Body'}],
        teasers: {
          columns: [...columns],
          data: []
        }
      }
    },
    watch: {
      'filter' (to, from) {
        console.log('new value', to)
        this.fetch(to);
      }
    },
    methods: {
      downloadCSV () {
        this.$store.dispatch('DOWNLOAD_CSV', this.filter)
      },
      fetch (contentId) {
        let filter = this.filter
        this.$store.dispatch('FETCH_TEASER_TEMPLATE', contentId)
          .then((res) => {
            this.teasers.data = res;
            console.log("this.teasers.data : ", this.teasers.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      editTemplate(item){
        this.$router.push(`/admin/logos/editteasertemplate/${this.filter}/${item.eid}`);
      },
      create(){
        this.$router.push({ name: 'Create Corporation'})
      },
      createTeaserLine(){
        this.$router.push({ name: 'CreateTeaserLine'})
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
    },
    created() {
      this.fetch(1);
    },
    computed:{
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    }
  }
</script>

<style>
  .btn-icon{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Teaser/TeaserTemplate.vue